import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_tab_square",
  "use": "rt-portal-rt_tab_square-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-rt_tab_square\">\r\n<style type=\"text/css\">\r\n\t#rt-portal-rt_tab_square .st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n</style>\r\n<path class=\"st0\" d=\"M628.5,896V645.8c0-8.8,7.1-16,16-16H896c8.8,0,16,7.1,16,16V896c0,8.8-7.1,16-16,16H644.5\r\n\tC635.7,912,628.5,904.9,628.5,896z M644.5,112H896c8.8,0,16,7.2,16,16v250.1c0,8.8-7.2,16-16,16H644.5c-8.8,0-16-7.2-16-16V128\r\n\tC628.5,119.2,635.7,112,644.5,112z M128,629.8h249.7c8.8,0,16,7.2,16,16V896c0,8.8-7.2,16-16,16H128c-8.8,0-16-7.2-16-16V645.8\r\n\tC112,637,119.2,629.8,128,629.8z M128,112h249.7c8.8,0,16,7.2,16,16v250.1c0,8.8-7.2,16-16,16H128c-8.8,0-16-7.2-16-16V128\r\n\tC112,119.2,119.2,112,128,112z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_tab_square.svg
// module id = 1346
// module chunks = 124